import type { BaseQueryApi } from "@reduxjs/toolkit/query";
import { AuthService } from "@service/auth.service";

const authService = AuthService.instance;

type PrepareHeadersApi = Pick<BaseQueryApi, "getState">;

function hasPersistedAppUser(getState: PrepareHeadersApi["getState"]): boolean {
  const state = getState() as { auth?: { user?: unknown } };
  return !!state?.auth?.user;
}

/**
 * Attaches `Authorization` for RTK Query `fetchBaseQuery`.
 * When Cognito returns no tokens on the first read (possible without throwing), we retry
 * once with `forceRefresh: true` if Redux still shows a signed-in user.
 */
const prepareAuthHeaders = async (
  headers: Headers,
  api?: PrepareHeadersApi,
): Promise<Headers> => {
  let bearer = await authService.getAccessToken();
  if (
    !bearer &&
    api?.getState &&
    hasPersistedAppUser(api.getState) &&
    !authService.isPatient
  ) {
    bearer = await authService.getAccessToken({ forceRefresh: true });
  }
  if (bearer) {
    headers.set("Authorization", bearer);
  } else {
    headers.delete("Authorization");
  }
  return headers;
};

export default prepareAuthHeaders;
